import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './root-reducers';

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
};

const reduxDevTool =
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools(applyMiddleware(thunk.withExtraArgument({ storage })))
    : compose(applyMiddleware(thunk.withExtraArgument({ storage })));
// When reloading the page, the state data in Redux will be reset to its initial values because Redux stores the state in memory.
// To maintain the state data even after a page reload
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, reduxDevTool);
export const persistor = persistStore(store);

export default store;
